<template>
    <!-- role="alert": los lectores de pantalla anuncian el mensaje en cuanto aparece -->
    <span
        v-show="errors_form.has(attribute_name)"
        class="form-control-feedback font-weight-bold"
        role="alert"
    >{{ errors_form.first(attribute_name) }}</span>
</template>
<script>
export default {
    props: ["attribute_name", "errors_form"]
};
</script>